module.exports = __webpack_public_path__ + "img/custom-item3-5.9c816d6.png";